export const applyDiscount = (value: number, discount: number) => {
  const clampedDiscount = Math.min(100, Math.max(0, discount));
  return value - (value * clampedDiscount) / 100;
};
